import { type StateCreator } from 'zustand';

export type CustomHexSlice = {
  hexes: string[];
  setHexes: (hexes: string[]) => void;
  addHex: (hex: string) => void;
  removeHex: (hex: string) => void;
  clearHexes: () => void;
};

export type CreateCustomHexSlice = (
  initialState: Pick<CustomHexSlice, 'hexes'>,
) => StateCreator<CustomHexSlice, [], [], CustomHexSlice>;

export const createCustomHexSlice: CreateCustomHexSlice = (initialState) => (set) => ({
  hexes: initialState.hexes ?? [],
  setHexes: (hexes: string[]) => set({ hexes }),
  addHex: (hex: string) =>
    set((state) => ({
      hexes: state.hexes.includes(hex) ? state.hexes : [...state.hexes, hex],
    })),
  removeHex: (hex: string) =>
    set((state) => ({
      hexes: state.hexes.filter((h) => h !== hex),
    })),
  clearHexes: () => set({ hexes: [] }),
});
